import React from "react";
import Dashboard from "./views/admin/dashboard";
import {
  MdArticle,
  MdPerson,
  MdDashboard,
  MdImage,
  MdVideoLibrary,
  MdViewCarousel,
  MdMenuBook,
  MdInfo,
  MdBrush,
} from "react-icons/md";
import { MdOutlineAddReaction } from "react-icons/md";
import { FaQuestionCircle } from "react-icons/fa";
import { RiImageCircleFill } from "react-icons/ri";
import { FaComments } from "react-icons/fa6";
import { BsPersonVcardFill } from "react-icons/bs";
import { MdSchool } from "react-icons/md";
import Carousel from "./views/admin/carousel";
import AddCarousel from "./views/admin/carousel/components/AddCarousel";
import EditCarousel from "./views/admin/carousel/components/EditCarousel";
import Posts from "./views/admin/posts";
import AddPost from "./views/admin/posts/components/AddPosts";
import Categories from "./views/admin/posts/categories";
import EditPost from "./views/admin/posts/components/EditPosts";
import User from "./views/admin/users";
import AddUser from "./views/admin/users/components/AddUser";
import EditUser from "./views/admin/users/components/EditUser";
import Logo from "./views/admin/logo";
import AddLogo from "./views/admin/logo/components/AddLogo";
import EditLogo from "./views/admin/logo/components/EditLogo";
import Video from "./views/admin/video";
import AddVideo from "./views/admin/video/components/AddVideo";
import EditVideo from "./views/admin/video/components/EditVideo";
import Foto from "./views/admin/foto";
import AddFoto from "./views/admin/foto/components/AddFoto";
import EditFoto from "./views/admin/foto/components/EditFoto";
import VisiMisi from "./views/admin/visi-misi";
import EditVisi from "./views/admin/visi-misi/components/EditVisi";
import Sambutan from "./views/admin/sambutan";
import EditSambutan from "./views/admin/sambutan/components/EditSambutan";
import Abouts from "./views/admin/abouts";
import AddAbouts from "./views/admin/abouts/components/AddAbouts";
import EditAbouts from "./views/admin/abouts/components/EditAbouts";
import Testimoni from "./views/admin/testimoni";
import AddTestimoni from "./views/admin/testimoni/components/FormTestimoni";
import EditTestimoni from "views/admin/testimoni/components/EditTestimoni";
// import Faq from "./views/admin/faq";
import AddVisi from "views/admin/visi-misi/components/AddVisi";
import Visi from "./views/admin/visi-misi";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdDashboard className="h-6 w-6" />,
    component: <Dashboard />,
  },
];

const konten = [
  {
    name: "Postingan",
    layout: "/admin",
    icon: <MdArticle className="h-6 w-6" />,
    path: "posts",
    component: <Posts />,
  },
  {
    name: "Tambah Postingan",
    layout: "/admin",
    path: "add-posts",
    hidden: true,
    component: <AddPost />,
  },
  {
    name: "Edit Postingan",
    layout: "/admin",
    path: "edit-posts/:id",
    hidden: true,
    component: <EditPost />,
  },
  {
    name: "Kategori Postingan",
    layout: "/admin",
    path: "categories",
    hidden: true,
    component: <Categories />,
  },
  {
    name: "Carousel",
    layout: "/admin",
    path: "carousel",
    icon: <MdViewCarousel className="h-6 w-6" />,
    component: <Carousel />,
  },
  {
    name: "Tambah Carousel",
    layout: "/admin",
    path: "add-carousel",
    hidden: true,
    component: <AddCarousel />,
  },
  {
    name: "Edit Carousel",
    layout: "/admin",
    path: "edit-carousel/:id",
    hidden: true,
    component: <EditCarousel />,
  },
  {
    name: "Testimoni",
    layout: "/admin",
    icon: <MdOutlineAddReaction className="h-6 w-6" />,
    path: "testimoni",
    component: <Testimoni />,
  },
  {
    name: "Tambah Testimoni",
    layout: "/admin",
    path: "add-testimoni",
    hidden: true,
    component: <AddTestimoni />,
  },
  {
    name: "Edit Testimoni",
    layout: "/admin",
    path: "edit-testimoni/:id",
    hidden: true,
    component: <EditTestimoni />,
  },
  // {
  //   name: "FAQ",
  //   layout: "/admin",
  //   icon: <FaQuestionCircle className="h-6 w-6" />,
  //   path: "faq",
  //   component: <Faq />,
  // },


];

const profil = [
  {
    name: "Visi",
    layout: "/admin",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <Visi/>,
    path: "visi"
  },
  {
    name: "Tambah Visi",
    layout: "/admin",
    path: "add-visi",
    component: <AddVisi />,
    hidden: true
  },
  {
    name: "Edit Visi",
    layout: "/admin",
    path: "edit-visi/:id",
    hidden: true,
    component: <EditVisi />,
  },
  {
    name: "Sambutan",
    layout: "/admin",
    path: "sambutan",
    icon: <BsPersonVcardFill className="h-6 w-6" />,
    component: <Sambutan />,
  },
  {
    name: "Edit Sambutan",
    layout: "/admin",
    path: "edit-sambutan/:id",
    hidden: true,
    component: <EditSambutan />,
  },
  {
    name: "Tentang",
    layout: "/admin",
    path: "abouts",
    icon: <MdInfo className="h-6 w-6" />,
    component: <Abouts />,
  },
  {
    name: "Add Abouts",
    layout: "/admin",
    path: "add-abouts",
    hidden: true,
    component: <AddAbouts />,
  },
  {
    name: "Edit Abouts",
    layout: "/admin",
    path: "edit-abouts/:id",
    hidden: true,
    component: <EditAbouts />,
  },
];

const tampilan = [
  {
    name: "Logo",
    layout: "/admin",
    path: "logo",
    icon: <RiImageCircleFill className="h-6 w-6" />,
    component: <Logo />,
  },
  {
    name: "Add Logo",
    layout: "/admin",
    path: "add-logo",
    hidden: true,
    component: <AddLogo />,
  },
  {
    name: "Edit Logo",
    layout: "/admin",
    path: "edit-logo/:id",
    hidden: true,
    component: <EditLogo />,
  },
];

const media = [
  {
    name: "Galeri Foto",
    layout: "/admin",
    icon: <MdImage className="h-6 w-6" />,
    path: "foto",
    component: <Foto />,
  },
  {
    name: "Tambah Media Foto",
    layout: "/admin",
    path: "add-foto",
    hidden: true,
    component: <AddFoto />,
  },
  {
    name: "Edit Media Foto",
    layout: "/admin",
    path: "edit-foto/:id",
    hidden: true,
    component: <EditFoto />,
  },
  {
    name: "Galeri Video",
    layout: "/admin",
    icon: <MdVideoLibrary className="h-6 w-6" />,
    path: "video",
    component: <Video />,
  },
  {
    name: "Tambah Media Video",
    layout: "/admin",
    path: "add-video",
    hidden: true,
    component: <AddVideo />,
  },
  {
    name: "Edit Media Video",
    layout: "/admin",
    path: "edit-video/:id",
    hidden: true,
    component: <EditVideo />,
  },
];

const pengaturan = [
  {
    name: "User",
    layout: "/admin",
    path: "user",
    icon: <MdPerson className="h-6 w-6" />,
    component: <User />,
  },
  {
    name: "Tambah User",
    layout: "/admin",
    path: "add-user",
    hidden: true,
    component: <AddUser />,
  },
  {
    name: "Edit User",
    layout: "/admin",
    path: "edit-user/:id",
    hidden: true,
    component: <EditUser />,
  },
];

export default routes;
export { konten };
export { profil };
export { tampilan };
export { media };
export { pengaturan };
